import i18n from "../../../../constants/i18n";
import { AUDITOR_WORKLOAD_DIVISION_BY_CSR_HEADERS } from "../../../../constants/table-custom-headers/Auditor";
import getWorkloadStore from "../../../../stores/auditor-store/workload-store";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";

const WorkloadDataByCSR = withLiteObserverAndTheme(() => {
  const { workloadDataByCSRArray } = getWorkloadStore().getWorkloadArraysData();

  return (
    <Et3Table
      columns={AUDITOR_WORKLOAD_DIVISION_BY_CSR_HEADERS}
      rows={workloadDataByCSRArray}
      title={i18n.get("DIVISION_BY_CSR")}
      shouldBeFlagged={false}
      titleKey={"DIVISION_BY_CSR"}
    />
  );
});

export default WorkloadDataByCSR;
